/**
 * Chaves de cache da sessão.
 *
 * Mora em `services/`, e não em `modules/auth/services/`, porque a sessão é
 * infraestrutura: `compositions/hooks/useSession.ts` é quem a consome, e
 * `compositions/` não pode importar de `modules/` (docs/01-arquitetura.md).
 * Fosse a factory do módulo, o hook cross-module precisaria de uma chave inline —
 * e chave inline é exatamente como o cache se parte em dois sem ninguém notar.
 *
 * A sessão não tem escopo na chave, ao contrário das demais entidades: ela **é** o
 * escopo. Ao trocar de sessão o cache inteiro é descartado (ver `useSignOut`), e
 * não só o ramo de uma entidade.
 */
export const sessionsKeys = {
  all: ['sessions'] as const,
  current: () => [...sessionsKeys.all, 'current'] as const,
};
